export const decodePhoneNumber = (formattedPhone: string): string => {
  const rawPhone = formattedPhone.replace(/[-(). ]/g, "");
  return rawPhone;
};
